<shared-header *ngIf="!isMobile"></shared-header>

<router-outlet></router-outlet>

<shared-footer *ngIf="!isMobile"></shared-footer>

